import React from 'react';
import PropTypes from 'prop-types';
import { /* CircleIcon, */ Toggle } from '@zola/zola-ui';

// assets
import travelImg from 'assets/images/website/manage-redesign/travel.svg';
import registryImg from 'assets/images/website/manage-redesign/registry.svg';
import eventImg from 'assets/images/website/manage-redesign/schedule.svg';
import weddingPartyImg from 'assets/images/website/manage-redesign/wedding-party.svg';
import photoImg from 'assets/images/website/manage-redesign/photos.svg';
import poiImg from 'assets/images/website/manage-redesign/things-to-do.svg';
import rsvpImg from 'assets/images/website/manage-redesign/rsvp.svg';
import faqImg from 'assets/images/website/manage-redesign/faq.svg';
import css from './HidePagesModal.module.less';

const iconMap = {
  travel: travelImg,
  registry: registryImg,
  event: eventImg,
  wedding_party: weddingPartyImg,
  photo: photoImg,
  poi: poiImg,
  rsvp: rsvpImg,
  faq: faqImg,
};

function Page({ id, type, title, hidden, onToggle }) {
  return (
    <li className={css.item}>
      <div className="hide-page-info">
        <img
          src={iconMap[type.toLowerCase()]}
          alt={`${title.toLowerCase()} icon`}
          height="60"
          width="60"
        />
        <span className={css.itemTitle}>{title}</span>
        {type === 'RSVP' && (
          <div className="subtitle text-small text-muted margin-left hidden-xs">
            You must add guests to Guest List to use online RSVP
          </div>
        )}
      </div>
      <div className={css.itemToggleWrapper}>
        <div
          className="with-tooltip no-tooltip-on-mobile"
          data-tooltip='Control if guests see this page. Set to "Hidden" if you don&apos;t want to use it or it&apos;s still a work in progress. Set to "Visible" if you&apos;re ready to share.'
        >
          <Toggle input={{ onChange: () => onToggle(id, hidden), value: !hidden }} withIcons />
        </div>
      </div>
      {type === 'RSVP' && (
        <div className="subtitle text-small text-muted visible-xs rsvp-text">
          You must add guests to Guest List to use online RSVP
        </div>
      )}
    </li>
  );
}

Page.propTypes = {
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  type: PropTypes.string,
  title: PropTypes.string,
  hidden: PropTypes.bool,
  onToggle: PropTypes.func,
};

export default Page;



// WEBPACK FOOTER //
// ./src/components/manage/common/HidePagesModal/Page.jsx